/**
 * Authoritative paddock grazing defaults.
 * Canonical home is `detail.grazing.*`; flat `detail.*` is the legacy read shape still
 * filled by api/paddocks normalize until callers fully use projection.
 */
export const PADDOCK_GRAZING_DEFAULTS = {
    foo: 1700,
    stockingRate: 10,
    pastureGrowthRate: 25,
    defaultEnergyDensity: 11.5,
    defaultResidual: 1200,
    dailyGrowthRate: 25,
    targetStay: 7,
    lastGrazedDate: '2026-01-01',
}

/**
 * Apply grazing defaults onto a flat `detail` object (legacy API normalize shape).
 * Preserves historical merge rules from api/paddocks normalizePaddocks.
 */
export const withPaddockFlatDetailDefaults = (detail = {}) => {
    const d = detail && typeof detail === 'object' ? detail : {}
    const defaults = PADDOCK_GRAZING_DEFAULTS

    return {
        ...d,
        foo: d.foo !== undefined ? d.foo : defaults.foo,
        stockingRate: d.stockingRate !== undefined ? d.stockingRate : defaults.stockingRate,
        pastureGrowthRate: d.pastureGrowthRate !== undefined ? d.pastureGrowthRate : defaults.pastureGrowthRate,
        defaultEnergyDensity: d.defaultEnergyDensity ?? defaults.defaultEnergyDensity,
        defaultResidual: d.defaultResidual ?? defaults.defaultResidual,
        dailyGrowthRate: d.dailyGrowthRate ?? defaults.dailyGrowthRate,
        targetStay: d.targetStay ?? defaults.targetStay,
        lastGrazedDate: d.lastGrazedDate || defaults.lastGrazedDate,
    }
}

export default PADDOCK_GRAZING_DEFAULTS
